<template>
<div class="focused-panel">
  <div class="d-flex polytron-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create point" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select point" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete point" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>
  </div>

</div>
</template>

<script>
import 'vue-awesome/icons/arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/check'
import Vue from 'vue'

import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import uuidV1 from 'uuid/v1'

export default {
  name: 'transformer',
  components: {

  },
  mixins: [FeatureEditorMixin],
  data() {
    return {
      markLastModified: false,
      featureId: null,
      addPolyEnabled: false,
      addLineEnabled: false,
      addPointEnabled: false,
      wellAttrs: {
        description: 'transformer-dtron',
      },
      wellLayerName: 'v4:wellpad_infrastructure',
      geometryName: 'geom',
      idName: 'id',
      geomType: 'Point',
      identName: 'ident',
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters['project/currentProject']
    }
  },
  methods: {
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/TransformerEditor.vue